// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-title {
  width: auto;
}

ion-content::part(scroll) {
  overflow-y: hidden;
}

ion-toolbar.ios {
  padding-top: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/form-components/form-date-picker-w-header/form-date-picker-w-header.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAGI;EACI,4BAAA;AAAR","sourcesContent":["ion-title {\n    width: auto;\n}\n\nion-content::part(scroll) {\n    overflow-y: hidden;\n}\n\nion-toolbar {\n    &.ios {\n        padding-top: 10px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
